import React from 'react';
import {observer} from 'mobx-react-lite';
import Icon from '../../../../../icons/icon/icon';
import IconDropDownMediumArrow from '../../../../../icons/icon-drop-down-medium-arrow/icon-drop-down-medium-arrow';
import CheckboxesTreeItemStore from '../../stores/checkboxes-tree-item-store';
import CheckboxesTreeStore from '../../stores/checkboxes-tree-store';
import './checkboxes-tree-item.scss';
import {CHECKBOX_SIZES, TristateCheckbox} from "../../../../tristate-checkbox/tristate-checkbox";
import FontBody2 from "../../../../../fonts/font-body2/font-body2";

interface ICheckboxesTreeItemProps {
    itemStore: CheckboxesTreeItemStore;
    listStore: CheckboxesTreeStore;
    parentDisabled?: boolean;
}

/**
 * Renders a single nested checkbox node with its children.
 * Uses observer to subscribe to just this node's observable state for fine-grained updates.
 */
const CheckboxesTreeItem: React.FC<ICheckboxesTreeItemProps> = observer((
    {
        itemStore,
        listStore,
        parentDisabled = false}
) => {
    const id = itemStore.pathIndex();
    const hasChildren = itemStore.hasChildren();
    const expanded = listStore.isExpanded(id);
    const allChildrenDisabled = hasChildren && itemStore.areAllChildrenDisabled();
    const isItemDisabled = Boolean(listStore.isDisabled() || itemStore.isDisabled() || parentDisabled || allChildrenDisabled);
    const isHidden = itemStore.isHidden();

    return <div className={`checkboxes-tree-item ${isHidden ? 'hidden' : ''}`}>
        <div className={`checkboxes-tree-item-row ${isItemDisabled ? 'disabled-item' : ''} ${hasChildren ? 'has-children': ''}`}
             onClick={() => listStore.handleRowClick(itemStore, isItemDisabled, hasChildren)}>
            { hasChildren ?
                    <div className={`expand-indicator ${expanded ? 'expanded' : ''}`}>
                        <Icon Component={IconDropDownMediumArrow}/>
                    </div> : <div/>
            }

            <div className="checkboxes-tree-item-label">
                <div className="tristate-checkbox-wrapper" onClick={(e) => e.stopPropagation()}>
                    <TristateCheckbox
                        label={""}
                        value={itemStore.getCheckBoxValue()!}
                        size={CHECKBOX_SIZES.MEDIUM}
                        onChange={(newState) => listStore.handleCheckboxChange(itemStore, newState)}
                        disabled={isItemDisabled}
                    />
                </div>
                <FontBody2>{itemStore.displayText}</FontBody2>
            </div>
        </div>

        {hasChildren && (
            <div className={`checkboxes-tree-children ${!expanded ? 'hidden' : ''} ${isItemDisabled ? 'disabled-by-parent' : ''}`}>
                {itemStore.getChildrenStores().map((child) => (
                    <CheckboxesTreeItem
                        key={child.pathIndex()}
                        itemStore={child}
                        listStore={listStore}
                        parentDisabled={isItemDisabled}
                    />
                ))}
            </div>
        )}
    </div>
});

export default CheckboxesTreeItem;


